export default {
    bookings: [],
    activeBooking: {isXeroBooking: true, customer: {}},
    manageBookingDialog: false,
    manageDeleteBookingDialog: false,
    previewJobDialog: false,
    dailyValue: 0,
    dailySales: 0,
    dailySalesBookings:[],
    entries: [],
    reschedule: [],
    cancellation: [],
    cumulative: {turnover: "", commission: []}
}
